import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useParams } from "react-router-dom";
import { createPortal } from "react-dom";
import Filter, { FormWrap } from "../modal/Filter";
import Button from "../button/index";
import {$apiV2, API_URL_V2} from "../../config/api";
import { openVideoList } from "../../helpers/service";
import { formatMatchScore, getMatchScoreParts } from "../../helpers/matchScore";


// Images
import playEmpty from "../../images/ic_play-empty.svg";
import play from "../../images/ic_play.svg";
import playMatchBlue from "../../images/play_match_blue.svg";
import playActive from "../../images/ic_play_active.svg";
import playActiveBlue from "../../images/ic_play_active_blue.svg";
import playinball from "../../images/ic_playinball.svg";
import playInBallBlue from "../../images/playInBall_blue.svg";
import statistics from "../../images/ic_statistics.svg";
import statisticsBlue from "../../images/statistics_blue.svg";
import formation from "../../images/football-field.svg";
import formationBlue from "../../images/football-field-blue.svg";
import moreDots from "../../images/ic_more.svg";
import playInBall from "../../images/ic_playinball.svg";
import metrica from "../../images/metrica-logo.png"
import { swapInTeamLogoPlaceholder, teamLogoPlaceholder } from "../../helpers/teamLogo";

import download from "../../images/ic_download.svg";
import download_blue from "../../images/download_blue.svg";

// Componenst
import Empty from "../../components/empty/index";
import { Tooltip as ReactTooltip } from "react-tooltip";

// Language
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import Moment from "react-moment";
import { breakpoints } from "../../style/size";
import {
  Action,
  ButtonFilter,
  MatchContent,
  MatchInfo,
} from "../../style/MatchTable";
import arrowIconUp from "../../images/up.svg";
import arrowIconDown from "../../images/down.svg";
import TextInput, { InputWrapper } from "../inputs/TextInput";
import { $apiV1 } from "../../config/api";
import { Formation } from "../Formation";
import { NotificationList } from "../notification/NotificationList";
import { useNotification } from "../notification/useNotification";
import { getTeamParamMarkers } from "../../helpers";
import { useDispatch, useSelector } from "react-redux";
import { downloadVideosActions } from "../../store/download_videos/downloadVideosSlice";
import { TopCardInfo, WrappContent } from "../../style/Overview";
import useOutsideClick from "../../hooks/useOutsideClick";
import { useLexicon } from "../../hooks/useLexicon";

export const MatchWrap = styled.div`
  border-radius: 8px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  background-color: ${(props) => props.theme.linesOpacity};
  height: fit-content;
  margin-bottom: 30px;
  overflow: hidden;
`;

export const TeamStats = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 0.5px solid ${(props) => props.theme.borderSubtle};

  &:last-child {
    border-bottom: none;
  }

  &:nth-child(even) {
    background: ${(props) => props.theme.cardBg};
  }
`;

export const RoundSubheader = styled.div`
  padding: 6px 16px;
  text-align: left;
  color: ${(props) => props.theme.green};
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  background-color: ${(props) => props.theme.accentBg};
  border-bottom: 0.5px solid ${(props) => props.theme.accentBorder};
  font-family: "SatoshiMedium";
`;

export const TeamScore = styled.div`
  padding: 8px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 80%;
`;

export const TeamOptions = styled.div`
  min-width: 160px;
  width: 20%;
  background: ${(props) => props.theme.cardBgAlt};
  border-left: 0.5px solid ${(props) => props.theme.borderColor};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 0 12px;

  img {
    width: 18px;
    height: 18px;
    opacity: 0.75;
    flex-shrink: 0;
    cursor: pointer;
    transition: opacity 0.15s;

    &:hover {
      opacity: 1;
    }
  }

  .react-tooltip {
    background: ${(props) => props.theme.dropdownBg} !important;
    opacity: 1 !important;
    color: ${(props) => props.theme.blueish} !important;
    font-family: "SatoshiMedium";
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    text-align: center;
    line-height: 18px;
    border: 1px solid ${(props) => props.theme.dropdownBorder} !important;
    padding: 4px 8px !important;
  }
`;

const VideoActionSlot = styled.span`
  align-items: center;
  display: flex;
  flex: 0 0 18px;
  height: 18px;
  justify-content: center;
  position: relative;
  width: 18px;
`;

const UnavailableVideoLabel = styled.span`
  color: ${(props) => props.theme.textMuted};
  font-family: "SatoshiMedium";
  font-size: 10px;
  font-weight: 500;
  line-height: 18px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: not-allowed;
  white-space: nowrap;
`;

export const PopupOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 9999;
`;

export const PopupContent = styled.div`
  background: #000000;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  padding: 32px 40px;
  max-width: 520px;
  width: 100%;
  text-align: center;
`;

export const PopupMessage = styled.p`
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 24px;
`;

export const PopupActions = styled.div`
  display: flex;
  justify-content: center;
`;

export const Home = styled.div`
  width: 40%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  padding: 0 16px;

  .react-tooltip {
    background: ${(props) => props.theme.dropdownBg} !important;
    opacity: 1 !important;
    color: ${(props) => props.theme.blueish} !important;
    font-family: "SatoshiMedium";
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    text-align: center;
    line-height: 18px;
    border: 1px solid ${(props) => props.theme.dropdownBorder} !important;
    padding: 4px 8px !important;
  }

  &.awayTeam {
    justify-content: flex-end;
  }

  img {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    object-fit: contain;
  }

  h4 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0px;
    text-align: left;
    line-height: 18px;
    max-width: 12vw;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  h4.teamPageName {
    max-width: 10vw;
  }

  @media screen and (max-width: 1880px) {
    h4.teamPageName { max-width: 9vw; }
  }
  @media screen and (max-width: 1780px) {
    h4.teamPageName { max-width: 8vw; }
  }
  @media screen and (max-width: 1520px) {
    h4.teamPageName { max-width: 7vw; }
  }
  @media screen and (max-width: 1455px) {
    h4.teamPageName { max-width: 6vw; }
  }
  @media screen and (max-width: 1370px) {
    h4.teamPageName { max-width: 5vw; }
  }
  @media screen and (max-width: 1300px) {
    h4.teamPageName { max-width: 12vw; }
  }
`;

export const Score = styled.div`
  width: 20%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;

  &.scorePlayerStat {
    width: 100%;
    text-align: left;
    align-items: flex-start;
  }

  h5 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0px;
    text-align: left;
    line-height: normal;
    display: flex;

    & > span {
      color: ${(props) => props.theme.white};
      font-family: "SatoshiMedium";
      font-size: 13px;
      font-weight: 500;
      line-height: normal;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }

    &.playerStatTitle {
      color: ${(props) => props.theme.white};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 95%;
    }
  }

  h3 {
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;

    time {
      opacity: 1;
      color: ${(props) => props.theme.textMuted};
      font-family: "SatoshiMedium";
      font-size: 11px;
      font-weight: 500;
      letter-spacing: 0px;
      text-align: center;
    }
  }

  h4 {
    margin-top: 4px;
    opacity: 1;
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 2px;
    text-align: center;
    line-height: 22px;
    color: ${(props) => props.theme.white};
  }

  span {
    font-family: "SatoshiMedium";
    font-size: 11px;
    font-weight: 500;
    color: ${(props) => props.theme.green};
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
    max-width: 15vw;
    white-space: nowrap;
  }
`;

export const TeamScoreMobile = styled.div`
  padding: 10px;
  width: 100%;
  position: relative;

  h3 {
    opacity: 1;
    font-size: 12px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: center;
    line-height: 18px;
    time {
      font-family: "SatoshiMedium";
      color: rgba(115, 128, 137, 1);
    }
  }
`;

export const TopFunction = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    transform: rotate(90deg);
    margin-right: 5px;
  }

  h3 > span {
    font-family: "SatoshiMedium";
    font-size: 12px;
    font-weight: 500;
    color: ${(props) => props.theme.green};
    margin-left: 10px;
  }
`;

export const TeamScoreMobileContent = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: column;
`;
export const HomeResult = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  h5 {
    opacity: 1;
    color: rgba(54, 232, 45, 1);
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    font-style: Bold;
    letter-spacing: 0px;
    text-align: right;
    line-height: 24px;
    color: ${(props) => props.theme.white};
  }
`;
export const AwayResult = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  h5 {
    opacity: 1;
    color: rgba(54, 232, 45, 1);
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    font-style: Bold;
    letter-spacing: 0px;
    text-align: right;
    line-height: 24px;
    color: ${(props) => props.theme.white};
  }
`;
export const TeamMobile = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  h4 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 16px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
  }

  img {
    width: 20px;
    height: 20px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  margin-top: -40px;
  margin-bottom: 20px;
`;

export const DropdownWrapper = styled.div`
  position: relative;
  margin-bottom: 30px;
`;

export const OpenedDropdown = styled.div`
  position: absolute;
  z-index: 999;
  width: 100%;
  margin-top: 20px;
  border-radius: 2px;
  opacity: 1;
  background-color: ${(props) => props.theme.lines};
  max-height: 200px;
  overflow: scroll;
  border: 1px solid ${(props) => props.theme.borderColor};

  > div {
    opacity: 1;
    color: ${(props) => props.theme.blueish};
    font-family: "SatoshiRegular";
    font-size: 16px;
    font-weight: 400;
    font-style: Regular;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
    padding: 10px 6px;
    cursor: pointer;

    &:hover {
      background-color: ${(props) => props.theme.black};
    }
  }
`;

const ClickableStatsHint = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  color: ${(props) => props.theme.blueish};
  font-family: "SatoshiMedium";
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
`;

const ClickableStatsHintDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.green};
  box-shadow: 0 0 8px ${(props) => props.theme.green};
  flex-shrink: 0;
`;

const DownloadMenu = styled.div`
  position: fixed;
  z-index: 10002;
  min-width: 180px;
  border-radius: 6px;
  background: ${(props) => props.theme.dropdownBg};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
  padding: 4px 0;
  border: 1px solid ${(props) => props.theme.dropdownBorder};
`;

const DownloadMenuArrow = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;

  ${(props) =>
    props.$side === "right"
      ? css`
          left: -8px;
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
          border-right: 8px solid ${props.theme.dropdownBg};
        `
      : css`
          right: -8px;
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
          border-left: 8px solid ${props.theme.dropdownBg};
        `}
`;

const DownloadMenuOption = styled.button`
  width: 100%;
  border: none;
  background: transparent;
  padding: 7px 12px;
  text-align: left;
  color: ${(props) => props.theme.blueish};
  font-family: "SatoshiMedium";
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${(props) => props.theme.accentBg};
    color: ${(props) => props.theme.white};
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;
const Matches = ({
  table,
  onChangeData,
  season,
  playerTeams,
  styleTableWrapper = {},
  showTitle,
  type = 'player',
  controlled = false,
  hideFilterButton = false,
  showClickableStatsHint = false,
  playerId,
}) => {
  const l = useLexicon();
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ query: `(${breakpoints.mobile})` });
  const [openRow, setOpenRow] = useState(null);
  const [openFilter, setOpenFilter] = useState(false);
  const [choosenSeasson, setChoosenSeasson] = useState(season);
  const [availableSeasons, setAvailableSeason] = useState("");
  const [competitions, setCompetitions] = useState([]);
  const [choosenCompetition, setChoosenCompetition] = useState("");
  const [filteredMatches, setFilteredMatches] = useState(table);
  const [mathcesList, setMatchesList] = useState("");
  const [lastMatches, SetLastMatches] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setFilteredMatches(table);
  }, [table])

  const dispatch = useDispatch();

  //formation state
  const [openFormation, setOpenFormation] = useState(false);
  const [selectedFormationMatch, setSelectedFormationMatch] = useState(null);

  const { id } = useParams();
  const navigate = useNavigate();

  // On-Ball Events parameter id differs by context: team stats use 13,
  // player/GK stats use 14. This component is shared by both the player view
  // (type='player') and the team overview matches list (type='team'); sending
  // 14 for a team hit /stats/team with no matching markers -> "0 clips".
  const onBallEventsParamId = type === 'team' ? 13 : 14;

  const [open, setOpen] = useState(false);
  const [openCompetition, setOpenCompetition] = useState(false);
  const [openMatchesCount, setOpenMatchesCount] = useState(false);

  const [selectedSeason, setSelectedSeason] = useState("");
  const [selectedCompetition, setSelectedCompetition] = useState("");
  const [selectedMatch, setSelectedMatch] = useState("");
  const [isMetricaPopupOpen, setIsMetricaPopupOpen] = useState(false);
  const [metricaPopupMessage, setMetricaPopupMessage] = useState("");
  const [activeDownloadMenuMatchId, setActiveDownloadMenuMatchId] = useState(null);
  const [activeDownloadMenuPosition, setActiveDownloadMenuPosition] = useState(null);
  const [activeDownloadMenuSide, setActiveDownloadMenuSide] = useState("left");
  const [downloadingReportMatchId, setDownloadingReportMatchId] = useState(null);
  const downloadMenuRef = useRef(null);

  const { notifications, addNotification, removeNotification } =
    useNotification();
  const canDownloadReport = useSelector((state) => state.user.canDownloadReport);

  const handleCloseFormation = () => {
    setOpenFormation(false);
    setSelectedFormationMatch(null);
  };

  const handleOpenFormation = (match) => {
    setSelectedFormationMatch(match);
    setOpenFormation(true);
  };

  const handleClearFilter = () => {
    setChoosenSeasson();
    setSelectedSeason("");
    setCompetitions();
    setSelectedCompetition("");
  };

  const handleSeasonChoose = (item) => {
    setChoosenSeasson(item.id);
    setSelectedSeason(item?.year_season?.years || item?.year_season || item?.years);
    setSelectedCompetition("");
    setChoosenCompetition("");
    setOpen(false);
  };

  const handleCompetitionChoose = (item) => {
    setChoosenCompetition(item.competition_id);
    setSelectedCompetition(item.competition);
    setOpenCompetition(false);
  };

  const handleMatches = (item) => {
    SetLastMatches(item.value);
    setSelectedMatch(item.title);
    setOpenMatchesCount(false);
  };

  const setMoreInfo = (item) => {
    setOpenRow(openRow === item.id ? null : item.id);
  };

  const handleCloseMetricaPopup = () => {
    setIsMetricaPopupOpen(false);
    setMetricaPopupMessage("");
  };

  const closeDownloadMenu = useCallback(() => {
    setActiveDownloadMenuMatchId(null);
    setActiveDownloadMenuPosition(null);
  }, []);

  const canDownloadFullMatch = useCallback(
    (match) => Boolean(match?.videos?.[0]?.link),
    []
  );

  const canOpenDownloadMenu = useCallback(
    (match) => canDownloadFullMatch(match) || canDownloadReport === true,
    [canDownloadFullMatch, canDownloadReport]
  );

  const openDownloadMenu = useCallback(
    (event, match) => {
      event.preventDefault();
      event.stopPropagation();

      if (!match?.id || !canOpenDownloadMenu(match)) {
        return;
      }

      if (Number(activeDownloadMenuMatchId) === Number(match.id)) {
        closeDownloadMenu();
        return;
      }

      const rect = event.currentTarget.getBoundingClientRect();
      const menuWidth = 220;
      const viewportWidth =
        window.innerWidth || document.documentElement.clientWidth;
      const proposedLeft = rect.left - menuWidth - 12;
      const shouldOpenOnRight = proposedLeft < 8;

      const left = shouldOpenOnRight
        ? Math.min(viewportWidth - menuWidth - 8, rect.right + 12)
        : proposedLeft;

      setActiveDownloadMenuSide(shouldOpenOnRight ? "right" : "left");
      setActiveDownloadMenuPosition({
        top: rect.top + rect.height / 2,
        left,
      });
      setActiveDownloadMenuMatchId(match.id);
    },
    [activeDownloadMenuMatchId, canOpenDownloadMenu, closeDownloadMenu]
  );

  const handleDownloadFullMatchOption = useCallback(
    (match) => {
      const link = match?.videos?.[0]?.link;
      if (!link) {
        return;
      }
      closeDownloadMenu();
      downloadVideoLink(link);
    },
    [closeDownloadMenu]
  );

  const handleDownloadReportOption = useCallback(
    async (match) => {
      const matchId = Number(match?.id);
      if (!Number.isFinite(matchId) || downloadingReportMatchId !== null) {
        return;
      }

      // SMRTSTATS-404: on a player profile this menu must export only that
      // player's pages for the match. Without a player id (team page) it stays
      // the full match report it has always been.
      const requestedPlayerId = Number(playerId);
      const hasPlayer = Number.isFinite(requestedPlayerId) && requestedPlayerId > 0;

      const notifId = `downloading-match-report-${matchId}`;
      setDownloadingReportMatchId(matchId);
      closeDownloadMenu();
      addNotification("Download in progress...", "info", { id: notifId, duration: 0 });

      try {
        const response = await $apiV2.post(
          `/platform/match/${matchId}/export/report/pdf`,
          hasPlayer ? { player_id: requestedPlayerId } : {},
          { responseType: "blob" }
        );

        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.download = hasPlayer
          ? `player-match-report-${requestedPlayerId}-${matchId}.pdf`
          : `match-report-${matchId}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Match report download failed", error);
        addNotification("Error, please try again later.", "error");
      } finally {
        removeNotification(notifId);
        setDownloadingReportMatchId((currentValue) =>
          Number(currentValue) === matchId ? null : currentValue
        );
      }
    },
    [addNotification, closeDownloadMenu, downloadingReportMatchId, playerId, removeNotification]
  );

  const handleMetrica = async (item) => {
      const hasVideo = Boolean(item?.video || item?.videos?.some((video) => Boolean(video?.link)));
      if (!hasVideo) {
        return;
      }

      try {
          await $apiV2.get(
              `/metrica/${item.id}`,
          );

          setMetricaPopupMessage(
            "Metrica Nexus Container download started, you will receive the container via email."
          );
          setIsMetricaPopupOpen(true);
      } catch (err) {
          addNotification('Error, please try again later.', 'error');

      }
  }

  const handleSeasons = async () => {
    try {
      setLoading(true);
      let response;
      if (type === 'team') {
        response = await $apiV1.get(
          `/statistics/team_opt/${id}?year_season_id=${choosenSeasson}`
        );
      } else {
        response = await $apiV1.get(
          `/statistics/player_opt/${id}?year_season_id=${choosenSeasson}`
        );
      }

      setAvailableSeason(response.data.available_seasons);
      setCompetitions(response.data.matches_list);

      const filteredMatches = response?.data?.matches_list
        ?.filter((match) =>
          choosenCompetition
            ? match.competition_id === choosenCompetition
            : true
        )
        .map((match) => match.id);

      setMatchesList(filteredMatches);
      if (type === 'team') {
        setFilteredMatches(
          response?.data?.matches_list
            ?.filter((match) =>
              choosenCompetition
                ? match.competition_id === choosenCompetition
                : true
            )
        )
        onChangeData?.(response?.data, choosenSeasson);
        return
      } else {
        onChangeData?.(response.data, choosenSeasson);
      }
      // Filter matches to show based on the updated list
      // const matchesToShow = response.data.matches_list.filter((match) =>
      //   filteredMatches.includes(match.id)
      // );
    } catch (error) {
      console.error("Error fetching players:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (controlled) {
      return;
    }
    handleSeasons();
  }, [choosenSeasson, choosenCompetition, controlled]);

  const uniqueCompetitions = [];
  const seenNames = new Set();

  competitions?.forEach((item) => {
    if (!seenNames.has(item.competition)) {
      seenNames.add(item.competition);
      uniqueCompetitions.push(item);
    }
  });

  const handleSearch = async () => {
    if (mathcesList?.length > 0) {
      const updatedFilteredMatches = table.filter((match) =>
        mathcesList.includes(match.id)
      );
      setFilteredMatches(updatedFilteredMatches); // Update filtered matches
    }
    setOpenFilter(false);
  };

  const matches = [
    {
      id: 1,
      value: filteredMatches?.length,
      title: l(1066),
    },
    {
      id: 2,
      value: 3,
      title: l(1067),
    },
    {
      id: 3,
      value: 5,
      title: l(1068),
    },
    {
      id: 4,
      value: 10,
      title: l(1069),
    },
  ];

  const currentSelectedSeason = useMemo(() => {
    if (selectedSeason) return selectedSeason;
    if (availableSeasons?.length) {
      const foundedSeason = availableSeasons?.find((item) => item.id == season);
      if (season && foundedSeason) {
        return foundedSeason?.year_season?.years || foundedSeason?.year_season || foundedSeason?.years;
      }
    }
    return l(992);
  }, [season, selectedSeason, availableSeasons, l]);

  const getMatchMarkersListTeam = async (matchId, parameter) => {
    try {
      const response = await $apiV1.get(`/stats/team/${id}`, {
        params: {
          matches: matchId,
          params: parameter,
        },
      });

      const allMarkers = response.data?.stats?.flatMap((stat) =>
        stat.parameters.flatMap((param) => param.markers)
      );
      return Promise.resolve(allMarkers);
    } catch (error) {
      console.error("Error fetching data:", error);
      return Promise.reject(error);
    }
  };

  const getMatchMarkersListPlayer = async (matchId, parameter) => {
    try {
      const response = await $apiV1.get(`stats/player/${id}`, {
        params: {
          matches: matchId,
          params: parameter,
        },
      });

      const allMarkers = response.data?.stats?.flatMap((stat) =>
        stat.parameters.flatMap((param) => param.markers)
      );
      return Promise.resolve(allMarkers);
    } catch (error) {
      console.error("Error fetching data:", error);
      return Promise.reject(error);
    }
  };

  const handleClickMatchParam = async (param_id, match, new_tab) => {
    try {
      const controller = new AbortController();
      addNotification(`Fetching clips. Please don't close or refresh the page till the download is completed.`, "info", controller);
      document.body.classList.add('loading-cursor');
      const data = type === 'player' ? await getMatchMarkersListPlayer(match?.id, param_id) : await getMatchMarkersListTeam(match?.id, param_id);

      if (Array.isArray(data) && data?.length > 0) {
        const markers = data?.join(",");
        openVideoList(markers, `On Ball Events - ${match?.home_team} ${match?.away_team}`, new_tab)
      } else {
        addNotification(
          `There are 0 clips in the response from the server.`,
          "warning"
        );
      }
    } catch (e) {
      console.log("error get param markers", e);
      if (e.type === "canceled") {
        addNotification(
          `The request to receive clips of the match has been canceled.`,
          "warning"
        );
        return;
      }
      addNotification(`Error in receiving match events. ${e.message}`, "error");
    } finally {
      document.body.classList.remove("loading-cursor");
    }
  };

  const downloadVideoLink = (link) => {
    const videoUrl = btoa(link);
    const url = `${API_URL_V2}/video/download/${videoUrl}`;
    console.log('url', url);
    window.open(url, '_blank')
  }

  const getColorScore = (item) => {
    const isLight = localStorage.getItem("theme") === "light";
    const WIN  = "#36E82D";      // natural green — positive result
    const DRAW = "#E8D02D";      // yellow — neutral
    const LOSS = "#F20A46";      // red — negative result

    const isTeamHome = playerTeams
      ?.filter((t) => t != null)
      ?.map((t) => t.name)
      ?.includes(item.home_team);

    let result;
    if (isTeamHome) {
      result = item.home_team_score > item.away_team_score ? "win"
             : item.home_team_score < item.away_team_score ? "loss"
             : "draw";
    } else {
      result = item.home_team_score < item.away_team_score ? "win"
             : item.home_team_score > item.away_team_score ? "loss"
             : "draw";
    }

    if (result === "win")  return WIN;
    if (result === "draw") return DRAW;
    return LOSS;
  };

  const seasonDropdownRef = useOutsideClick(() => {
    if (open) {
      setOpen(false);
    }
  });

  const competitionDropdownRef = useOutsideClick(() => {
    if (openCompetition) {
      setOpenCompetition(false);
    }
  });

  const mathesCountDropdownRef = useOutsideClick(() => {
    if (openMatchesCount) {
      setOpenMatchesCount(false);
    }
  });

  const getCompetitionName = (row) => {
    const c = row?.competition;
    if (typeof c === 'string') return c;
    if (c != null && typeof c === 'object') return c?.name ?? c?.title ?? null;
    return row?.competition__name ?? row?.competition_name ?? null;
  };

  const getRoundName = (row) => {
    const val = row?.round_name ?? row?.round ?? row?.matchday ?? row?.match_round ?? null;
    if (val != null && typeof val === 'object') return val?.name ?? val?.title ?? null;
    return val;
  };

  const getCompetitionRoundLabel = (row) => {
    const comp = getCompetitionName(row);
    const round = getRoundName(row);
    if (!comp && !round) return null;
    if (comp && round) return `${comp} - ${round}`;
    return comp || round;
  };

  const sortedSlicedMatches = useMemo(() => {
    const arr = filteredMatches?.sort((a, b) => new Date(b.date) - new Date(a.date)) ?? [];
    if (controlled) {
      return arr;
    }
    return arr.slice(0, lastMatches ? lastMatches : table?.length ?? 0);
  }, [controlled, filteredMatches, lastMatches, table?.length]);

  const activeDownloadMatch = useMemo(() => {
    if (!activeDownloadMenuMatchId) {
      return null;
    }

    return (
      sortedSlicedMatches?.find(
        (match) => Number(match?.id) === Number(activeDownloadMenuMatchId)
      ) || null
    );
  }, [activeDownloadMenuMatchId, sortedSlicedMatches]);

  useEffect(() => {
    if (!activeDownloadMenuMatchId) {
      return;
    }

    const handleOutsideClick = (event) => {
      if (!downloadMenuRef.current) {
        return;
      }

      if (!downloadMenuRef.current.contains(event.target)) {
        closeDownloadMenu();
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        closeDownloadMenu();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleEscape);
    window.addEventListener("resize", closeDownloadMenu);
    window.addEventListener("scroll", closeDownloadMenu, true);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleEscape);
      window.removeEventListener("resize", closeDownloadMenu);
      window.removeEventListener("scroll", closeDownloadMenu, true);
    };
  }, [activeDownloadMenuMatchId, closeDownloadMenu]);

  return (
    <>
      <div>
        {showClickableStatsHint && (
          <ClickableStatsHint>
            <ClickableStatsHintDot />
            {t("smrtSearch.clickableStatsHint")}
          </ClickableStatsHint>
        )}
        {showTitle && (
          <WrappContent>
            <h2>{l(7)}</h2>
          </WrappContent>
        )}
        {!hideFilterButton && (
          <ButtonWrapper style={showTitle ? { marginBottom: 5 } : {}}>
            <ButtonFilter
              className="buttonFilter"
              onClick={() => setOpenFilter(!openFilter)}
            >
              {l(1018)}
            </ButtonFilter>
          </ButtonWrapper>
        )}
        {
          sortedSlicedMatches?.length > 0 ? (
            <MatchWrap style={styleTableWrapper}>
              {sortedSlicedMatches.map((item, index) => {
                const label = getCompetitionRoundLabel(item);
                const prevLabel = index > 0 ? getCompetitionRoundLabel(sortedSlicedMatches[index - 1]) : null;
                const showSubheader = label && label !== prevLabel;
                const hasVideo = Boolean(item?.video || item?.videos?.some((video) => Boolean(video?.link)));
                const hasDownloadOption = canOpenDownloadMenu(item);
                return (
                  <React.Fragment key={item.id}>
                    {showSubheader && (
                      <RoundSubheader>{label}</RoundSubheader>
                    )}
                    <TeamStats>
                      {!isMobile && (
                        <TeamScore>
                          <Home
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              window.open(`/tournaments/team/${item?.home_team_id}`)
                            }}
                          >
                            <img
                              src={item?.home_team_logo || teamLogoPlaceholder}
                              alt={item?.home_team ?? ""}
                              onError={swapInTeamLogoPlaceholder}
                            />{" "}
                            <h4 className={type === 'team' ? 'teamPageName' : ''} data-tooltip-id={`full-name-${item?.home_team}-${item.id}`}>
                              {item?.home_team}
                            </h4>
                            <ReactTooltip
                              id={`full-name-${item.home_team}-${item.id}`}
                              place="bottom"
                              content={item?.home_team}
                            />
                          </Home>
                          <Score>
                            {Boolean(item?.mins_played) && (
                              <span>{l(346)} {item?.mins_played}</span>
                            )}
                            <h3>
                              <Moment format="DD.MM.YYYY">{item?.date}</Moment>
                            </h3>
                            <h4
                              style={{
                                color: getColorScore(item),
                                cursor: 'pointer'
                              }}
                              onClick={() => {
                                window.open(
                                  `/tournaments/statistics/${item.id}`,
                                  "_blank"
                                )
                              }}
                            >
                              {formatMatchScore(item)}
                            </h4>
                          </Score>
                          <Home
                            className="awayTeam"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              window.open(`/tournaments/team/${item?.away_team_id}`)
                            }}
                          >
                            <img
                              src={item?.away_team_logo || teamLogoPlaceholder}
                              alt={item?.away_team ?? ""}
                              onError={swapInTeamLogoPlaceholder}
                            />{" "}
                            <h4 className={type === 'team' ? 'teamPageName' : ''} data-tooltip-id={`full-name-${item?.away_team}-${item.id}`}>
                              {item?.away_team}
                            </h4>
                            <ReactTooltip
                              id={`full-name-${item.away_team}-${item.id}`}
                              place="bottom"
                              content={item?.away_team}
                            />
                          </Home>
                        </TeamScore>
                      )}
                      {isMobile && (
                        <TeamScoreMobile>
                          <TeamScoreMobileContent>
                            <TopFunction>
                              {" "}
                              <h3>
                                <Moment format="DD.MM.YYYY">{item?.date}</Moment>
                                {Boolean(item?.mins_played) && (
                                  <span>{l(346)} {item?.mins_played}</span>
                                )}
                              </h3>

                              <img
                                src={moreDots}
                                alt={moreDots}
                                onClick={() => setMoreInfo(item)}
                              />
                            </TopFunction>
                            <HomeResult>
                              <TeamMobile
                                onClick={() => {
                                  window.open(`/tournaments/team/${item?.home_team_id}`)
                                }}
                              >
                                <img
                                  src={item?.home_team_logo || teamLogoPlaceholder}
                                  alt={item?.home_team ?? ""}
                                  onError={swapInTeamLogoPlaceholder}
                                />{" "}
                                <h4>{item?.home_team}</h4>
                              </TeamMobile>
                              {openRow === item.id && (
                                <MatchInfo style={{ top: "30%", right: "10px" }}>
                                  <MatchContent>
                                    <Action
                                      onClick={() => {
                                        if (item?.videos?.length > 0) {
                                          window.open(
                                            `/tournaments/match/video/${item.id}`,
                                            "_blank"
                                          );
                                        }
                                      }}
                                    >
                                      <img
                                        src={
                                          item?.videos?.length > 0
                                            ? localStorage.getItem("theme") ===
                                              "light"
                                              ? playActiveBlue
                                              : playActive
                                            : playEmpty
                                        }
                                        alt={
                                          localStorage.getItem("theme") ===
                                            "light"
                                            ? playMatchBlue
                                            : play
                                        }
                                      />
                                      <h4>{l(1019)}</h4>
                                    </Action>
                                    <Action
                                      onClick={() =>
                                        handleClickMatchParam(onBallEventsParamId, item)
                                      }
                                    >
                                      <img
                                        src={
                                          localStorage.getItem("theme") ===
                                            "light"
                                            ? playInBallBlue
                                            : playInBall
                                        }
                                        alt={playInBall}
                                      />
                                      <h4>{l(334)}</h4>
                                    </Action>
                                      <Action>
                                          <img src={metrica} style={{width: '20px', height: '20px'}} alt={metrica}></img>
                                          <h4>{l(1025)}</h4>
                                      </Action>
                                    <Action
                                      onClick={() =>
                                        window.open(
                                          `/tournaments/statistics/${item.id}`,
                                          "_blank"
                                        )
                                      }
                                    >
                                      <img
                                        src={
                                          localStorage.getItem("theme") ===
                                            "light"
                                            ? statisticsBlue
                                            : statistics
                                        }
                                        alt={statistics}
                                      />
                                      <h4>{l(1020)}</h4>
                                    </Action>
                                    <Action
                                      onClick={() => {
                                        handleOpenFormation(item);
                                      }}
                                    >
                                      <img
                                        src={
                                          localStorage.getItem("theme") ===
                                            "light"
                                            ? formationBlue
                                            : formation
                                        }
                                        alt={formation}
                                      />
                                      <h4>{l(1021)}</h4>
                                    </Action>

                                    {hasDownloadOption && (
                                      <Action
                                        style={{
                                          cursor: hasDownloadOption ? "pointer" : "not-allowed",
                                          opacity: hasDownloadOption ? 1 : 0.5,
                                        }}
                                        onClick={(event) => openDownloadMenu(event, item)}
                                      >
                                        <img
                                          src={
                                            localStorage.getItem("theme") ===
                                              "light"
                                              ? download_blue
                                              : download
                                          }
                                          alt={download}
                                        />
                                        <h4>{t("playlist.download")}</h4>
                                      </Action>
                                    )}
                                  </MatchContent>
                                </MatchInfo>
                              )}

                              <h5
                                style={{
                                  color: getColorScore(item),
                                }}
                                onClick={() => {
                                  window.open(
                                    `/tournaments/statistics/${item.id}`,
                                    "_blank"
                                  )
                                }}
                              >
                                {getMatchScoreParts(item)[0]}
                              </h5>
                            </HomeResult>
                            <AwayResult>
                              <TeamMobile
                                onClick={() => {
                                  window.open(`/tournaments/team/${item?.away_team_id}`)
                                }}
                              >
                                <img
                                  src={item?.away_team_logo || teamLogoPlaceholder}
                                  alt={item?.away_team ?? ""}
                                  onError={swapInTeamLogoPlaceholder}
                                />{" "}
                                <h4>{item?.away_team}</h4>
                              </TeamMobile>
                              <h5
                                style={{
                                  color: getColorScore(item),
                                }}
                                onClick={() => {
                                  window.open(
                                    `/tournaments/statistics/${item.id}`,
                                    "_blank"
                                  )
                                }}
                              >
                                {getMatchScoreParts(item)[1]}
                              </h5>
                            </AwayResult>
                          </TeamScoreMobileContent>
                        </TeamScoreMobile>
                      )}
                      {!isMobile && (
                        <TeamOptions>
                          <VideoActionSlot>
                            {hasVideo ? (
                              <img
                                src={
                                  localStorage.getItem("theme") === "light"
                                    ? playActiveBlue
                                    : playActive
                                }
                                alt={play}
                                onClick={() => {
                                  window.open(
                                    `/tournaments/match/video/${item.id}`,
                                    "_blank"
                                  );
                                }}
                                onContextMenu={() => {
                                  window.open(
                                    `/tournaments/match/video/${item.id}`,
                                    "_blank"
                                  );
                                }}
                                data-tooltip-id={`play-full-match-${item.id}`}
                              />
                            ) : (
                              <UnavailableVideoLabel
                                data-tooltip-id={`play-full-match-${item.id}`}
                              >
                                N/A
                              </UnavailableVideoLabel>
                            )}
                          </VideoActionSlot>
                          <img
                            src={
                              localStorage.getItem("theme") === "light"
                                ? playInBallBlue
                                : playinball
                            }
                            alt={playinball}
                            data-tooltip-id={`play-ball-in-play-${item.id}`}
                            onClick={() => handleClickMatchParam(onBallEventsParamId, item)}
                            onContextMenu={() =>
                              handleClickMatchParam(onBallEventsParamId, item, true)
                            }
                          />

                          <img
                            src={
                              localStorage.getItem("theme") === "light"
                                ? statisticsBlue
                                : statistics
                            }
                            alt={statistics}
                            onClick={() =>
                              navigate(`/tournaments/statistics/${item.id}`)
                            }
                            onContextMenu={() =>
                              window.open(
                                `/tournaments/statistics/${item.id}`,
                                "_blank"
                              )
                            }
                            style={{ cursor: "pointer" }}
                            data-tooltip-id={`see-match-statistics-${item.id}`}
                          />
                            <img
                                src={
                                    localStorage.getItem("theme") === "light"
                                        ? metrica
                                        : metrica
                                }
                                style={{
                                  width: '15px',
                                  height: '15px',
                                  cursor: hasVideo ? 'pointer' : 'not-allowed',
                                  opacity: hasVideo ? 1 : 0.5,
                                }}
                                alt={metrica}
                                onClick={() => {
                                  if (!hasVideo) {
                                    return;
                                  }
                                  handleMetrica(item);
                                }}
                                onContextMenu={(e) => {
                                  if (!hasVideo) {
                                    e.preventDefault();
                                    return;
                                  }
                                  handleMetrica(item);
                                }}
                                data-tooltip-id={`see-match-metrica-${item.id}`}
                            />
                          <img
                            src={
                              localStorage.getItem("theme") === "light"
                                ? formationBlue
                                : formation
                            }
                            alt={formation}
                            data-tooltip-id={`see-match-formation-${item.id}`}
                            onClick={() => handleOpenFormation(item)}
                            onContextMenu={() => handleOpenFormation(item)}
                          />

                          <img
                            src={
                              localStorage.getItem("theme") === "light"
                                ? download_blue
                                : download
                            }
                            alt={statistics}
                            onClick={(event) => openDownloadMenu(event, item)}
                            style={{
                              cursor: hasDownloadOption ? "pointer" : "not-allowed",
                              pointerEvents: hasDownloadOption ? "auto" : "none",
                              opacity: hasDownloadOption ? 1 : 0.3,
                            }}
                            data-tooltip-id={`download-video-${item.id}`}
                          />
                          <ReactTooltip
                            id={`download-video-${item.id}`}
                            place="bottom"
                            content={t("playlist.download")}
                          />
                          <ReactTooltip
                            id={`play-full-match-${item.id}`}
                            place="bottom"
                            content={hasVideo ? l(1019) : t("matchActions.videoNotAvailable")}
                          />
                          <ReactTooltip
                            id={`play-ball-in-play-${item.id}`}
                            place="bottom"
                            content={l(334)}
                          />
                          <ReactTooltip
                            id={`see-match-statistics-${item.id}`}
                            place="bottom"
                            content={l(1020)}
                          />
                            <ReactTooltip
                                id={`see-match-metrica-${item.id}`}
                                place="bottom"
                                content={hasVideo ? l(1126) : l(316)}
                            />
                          <ReactTooltip
                            id={`see-match-formation-${item.id}`}
                            place="bottom"
                            content={l(1021)}
                          />
                        </TeamOptions>
                      )}
                    </TeamStats>
                  </React.Fragment>
                );
              })}
            </MatchWrap>
          ) : (
            <div>
              <WrappContent>
                {!showTitle && <h2>{l(7)}</h2>}
              </WrappContent>
              <Empty style={{ height: 105 }} title={l(315)}/>
            </div>
          )
        }

        {!controlled && (
          <Filter
            openFilter={openFilter}
            setOpenFilter={setOpenFilter}
            onClick={() => handleClearFilter()}
          >
            <FormWrap style={{ marginBottom: "20px" }}>
              {availableSeasons && (
                <DropdownWrapper ref={seasonDropdownRef}>
                  <div style={{ position: "relative" }} onClick={() => setOpen(!open)}>
                    <TextInput
                      type="text"
                      value={currentSelectedSeason}
                      readOnly
                    />

                    <img
                      src={open ? arrowIconUp : arrowIconDown}
                      alt={arrowIconDown}
                      style={{
                        color: "#fff",
                        position: "absolute",
                        right: 0,
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  {open && (
                    <OpenedDropdown>
                      {availableSeasons?.map((item, index) => (
                        <div
                          key={index}
                          onClick={() => handleSeasonChoose(item)}
                        >
                          {item?.year_season?.years || item?.year_season || item?.years}
                        </div>
                      ))}
                    </OpenedDropdown>
                  )}
                </DropdownWrapper>
              )}

              {competitions && (
                <DropdownWrapper ref={competitionDropdownRef}>
                  <div
                    style={{ position: "relative" }}
                    onClick={() => setOpenCompetition(!openCompetition)}
                  >
                    <TextInput
                      type="text"
                      value={
                        selectedCompetition?.length == 0
                          ? l(993)
                          : selectedCompetition
                      }
                      readOnly
                    />
                    <img
                      src={openCompetition ? arrowIconUp : arrowIconDown}
                      alt={arrowIconDown}
                      style={{
                        color: "#fff",
                        position: "absolute",
                        right: 0,
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  {openCompetition && (
                    <OpenedDropdown>
                      {uniqueCompetitions?.map((item, index) => (
                        <div
                          key={index}
                          onClick={() => handleCompetitionChoose(item)}
                        >
                          {item.competition}
                        </div>
                      ))}
                    </OpenedDropdown>
                  )}
                </DropdownWrapper>
              )}

              <DropdownWrapper ref={mathesCountDropdownRef}>
                <div
                  style={{ position: "relative" }}
                  onClick={() => setOpenMatchesCount(!openMatchesCount)}
                >
                  <TextInput
                    type="text"
                    value={
                      selectedMatch?.length == 0 ? l(994) : selectedMatch
                    }
                    readOnly
                  />

                  <img
                    src={openMatchesCount ? arrowIconUp : arrowIconDown}
                    alt={arrowIconDown}
                    style={{
                      color: "#fff",
                      position: "absolute",
                      right: 0,
                      cursor: "pointer",
                    }}
                  />
                </div>

                {openMatchesCount && (
                  <OpenedDropdown>
                    {matches?.map((item, index) => (
                      <div key={index} onClick={() => handleMatches(item)}>
                        {item.title}
                      </div>
                    ))}
                  </OpenedDropdown>
                )}
              </DropdownWrapper>

              {loading ? (
                <Button title={l(1072)} disabled size={"full"} />
              ) : (
                <Button
                  title={l(906)}
                  onClick={() => handleSearch()}
                  size={"full"}
                />
              )}
            </FormWrap>
          </Filter>
        )}

        <Formation
          open={openFormation}
          handleClose={handleCloseFormation}
          match={selectedFormationMatch}
        />

        {isMetricaPopupOpen && (
          <PopupOverlay onClick={handleCloseMetricaPopup}>
            <PopupContent onClick={(e) => e.stopPropagation()}>
              <PopupMessage>{metricaPopupMessage}</PopupMessage>
              <PopupActions>
                <Button
                  title="Close"
                  onClick={handleCloseMetricaPopup}
                  size={"full"}
                />
              </PopupActions>
            </PopupContent>
          </PopupOverlay>
        )}

        {activeDownloadMenuMatchId &&
          activeDownloadMenuPosition &&
          activeDownloadMatch &&
          createPortal(
            <DownloadMenu
              ref={downloadMenuRef}
              style={{
                left: `${activeDownloadMenuPosition.left}px`,
                top: `${activeDownloadMenuPosition.top}px`,
                transform: "translateY(-50%)",
              }}
            >
              <DownloadMenuArrow $side={activeDownloadMenuSide} />
              <DownloadMenuOption
                type="button"
                onClick={() => handleDownloadFullMatchOption(activeDownloadMatch)}
                disabled={!canDownloadFullMatch(activeDownloadMatch)}
              >
                {l(1022)}
              </DownloadMenuOption>
              {canDownloadReport === true && (
                <DownloadMenuOption
                  type="button"
                  onClick={() => handleDownloadReportOption(activeDownloadMatch)}
                  disabled={downloadingReportMatchId !== null}
                >
                  {Number(downloadingReportMatchId) === Number(activeDownloadMatch?.id)
                    ? l(312)
                    : t("statistics.downloadReport")}
                </DownloadMenuOption>
              )}
            </DownloadMenu>,
            document.body
          )}
      </div>

      {/* display notifications */}
      <NotificationList
        notifications={notifications}
        onClose={removeNotification}
      />
    </>
  );
};

export default Matches;
